import React from 'react';
export function Mask() {
  return React.createElement("div", {
    className: "mask"
  });
}